import { call, put, takeLatest } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {
  GET_DEFAULT_MEDICATIONS_REQUEST,
  GET_DEFAULT_MEDICATIONS_SUCCESS,
  GET_DEFAULT_MEDICATIONS_ERROR
} from "../../actions";

function* workerDefaultMedications(): Generator<any> {
  try {
    const data: any = yield call(PatientsAPI.getDefaultMedications);

    yield put({
      type: GET_DEFAULT_MEDICATIONS_SUCCESS,
      payload: { defaultMedications: data }
    });
  } catch (error: any) {
    yield put({
      type: GET_DEFAULT_MEDICATIONS_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
  }
}

export function* watcherDefaultMedications() {
  yield takeLatest(GET_DEFAULT_MEDICATIONS_REQUEST, workerDefaultMedications);
}
